/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
import store from '../store'

export default [
  {
    path: '*',
    meta: {
      name: 'homepage',
      requiresAuth: true
    },
    redirect: {
      path: '/dashboard'
    }
  },
  // This  allows you to have pages apart of the app but no rendered inside the dash
  {
    path: '/',
    meta: {
      name: '',
      requiresAuth: false
    },
    component: () =>
      import(/* webpackChunkName: "routes" */ `@/views/LoginHome.vue`),
    // redirect if already signed in
    beforeEnter: (to, from, next) => {
      if (store.getters.authorized) {
        next('/dashboard')
      } else {
        next()
      }
    },
    children: [
      {
        path: '',
        component: () => import(`@/components/LoginForm.vue`)
      }
    ]
  },
  // add any extra routes that you want rendered in the dashboard as a child below. Change toolbar names here
  /** ************* Real use *****************/
  {
    path: '/dashboard',
    meta: {
      name: 'Dashboard View',
      requiresAuth: true
    },
    component: () => import(`@/views/DashboardView.vue`),
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import(`@/components/DashViews/Dashboard.vue`)
      },
      {
        path: 'md/company',
        meta: {
          name: 'Master Data',
          requiresAuth: true
        },
        // redirect if not has the permission
        beforeEnter: (to, from, next) => {
          if (store.getters.hasPermission(['MA_MASTER_DATA', 'MA_MD_COMPANY_READ'])) {
            next()
          } else {
            next('/dashboard')
          }
        },
        component: () => import(`@/components/DashViews/md/Company.vue`)
      },
      {
        path: 'md/customer',
        meta: {
          name: 'Master Data OIS',
          requiresAuth: true
        },
        beforeEnter: (to, from, next) => {
          if (store.getters.hasPermission(['MA_MASTER_DATA','MA_MD_CUSTOMER_READ'])) {
            next()
          } else {
            next('/dashboard')
          }
        },
        component: () => import(`@/components/DashViews/md/Customer.vue`)
      },
      {
        path: 'md/exchrate',
        meta: {
          name: 'Master Data OIS',
          requiresAuth: true
        },
        beforeEnter: (to, from, next) => {
          if (store.getters.hasPermission('MA_MASTER_DATA')) {
            next()
          } else {
            next('/dashboard')
          }
        },
        component: () => import(`@/components/DashViews/md/ExchangeRate.vue`)
      },
      {
        path: 'md/pricerule',
        meta: {
          name: 'Master Data OIS',
          requiresAuth: true
        },
        beforeEnter: (to, from, next) => {
          if (store.getters.hasPermission('MA_MASTER_DATA')) {
            next()
          } else {
            next('/dashboard')
          }
        },
        component: () => import(`@/components/DashViews/md/PriceRule.vue`)
      },
      {
        path: 'md/item',
        meta: {
          name: 'Master Data OIS',
          requiresAuth: true
        },
        beforeEnter: (to, from, next) => {
          if (store.getters.hasPermission('MA_MASTER_DATA')) {
            next()
          } else {
            next('/dashboard')
          }
        },
        component: () => import(`@/components/DashViews/md/Item.vue`)
      },
      {
        path: 'md/supplier',
        meta: {
          name: 'Master Data OIS',
          requiresAuth: true
        },
        beforeEnter: (to, from, next) => {
          if (store.getters.hasPermission('MA_MASTER_DATA')) {
            next()
          } else {
            next('/dashboard')
          }
        },
        component: () => import(`@/components/DashViews/md/Supplier.vue`)
      },
      {
        path: 'visit',
        meta: {
          name: 'Visit',
          requiresAuth: true
        },
        beforeEnter: (to, from, next) => {
          if (store.getters.hasPermission('MA_VISIT')) {
            next()
          } else {
            next('/dashboard')
          }
        },
        component: () => import(`@/components/DashViews/Visit.vue`)

      },
      {
        path: 'lead',
        meta: {
          name: 'Lead Website',
          requiresAuth: true
        },
        beforeEnter: (to, from, next) => {
          if (store.getters.hasPermission('MA_LEAD')) {
            next()
          } else {
            next('/dashboard')
          }
        },
        component: () => import(`@/components/DashViews/LeadWebsite.vue`)
      },
      {
        path: 'shodan',
        meta: {
          name: 'Shodan',
          requiresAuth: true
        },
        beforeEnter: (to, from, next) => {
          if (store.getters.hasPermission('MA_SHODAN')) {
            next()
          } else {
            next('/dashboard')
          }
        },
        component: () => import(`@/components/DashViews/Shodan.vue`)
      },
      {
        path: 'sales',
        meta: {
          name: 'Admin Sales',
          requiresAuth: true
        },
        beforeEnter: (to, from, next) => {
          if (store.getters.hasPermission('MA_SALES')) {
            next()
          } else {
            next('/dashboard')
          }
        },
        component: () => import(`@/components/DashViews/SalesAdm.vue`)
      },
      {
        path: 'quotation',
        meta: {
          name: 'Quotation',
          requiresAuth: true
        },
        beforeEnter: (to, from, next) => {
          if (store.getters.hasPermission('MA_QUOTATION')) {
            next()
          } else {
            next('/dashboard')
          }
        },
        component: () => import(`@/components/DashViews/Quotation.vue`)
      },
      {
        path: 'project',
        meta: {
          name: 'Project',
          requiresAuth: true
        },
        beforeEnter: (to, from, next) => {
          if (store.getters.hasPermission('MA_PROJECT')) {
            next()
          } else {
            next('/dashboard')
          }
        },
        component: () => import(`@/components/DashViews/Project.vue`)
      },
      {
        path: 'report/project',
        meta: {
          name: 'Report',
          requiresAuth: true
        },
        beforeEnter: (to, from, next) => {
          if (store.getters.hasPermission(['MA_REPORT', 'MA_REPORT_PROJECT'])) {
            next()
          } else {
            next('/dashboard')
          }
        },
        component: () => import(`@/components/DashViews/report/ReportProject.vue`)
      },
      {
        path: 'account',
        meta: {
          name: 'Account',
          requiresAuth: true
        },
        beforeEnter: (to, from, next) => {
          if (store.getters.hasPermission('MA_ACCOUNT')) {
            next()
          } else {
            next('/dashboard')
          }
        },
        component: () => import(`@/components/DashViews/Account.vue`)
      },
      // In the Toolbar
      {
        path: 'user-profile',
        meta: {
          name: 'User Profile',
          requiresAuth: true
        },
        component: () => import(`@/components/DashViews/ProfileAccount.vue`)
      }
     /** **************** END OF *******************/

      // {
      //   path: 'user-profile',
      //   meta: {
      //     name: 'User Profile',
      //     requiresAuth: true
      //   },
      //   component: () => import(`@/components/DashViews/ori/UserProfile.vue`)
      // },
      // {
      //   path: 'table-list',
      //   meta: {
      //     name: 'Table List',
      //     requiresAuth: true
      //   },
      //   component: () => import(`@/components/DashViews/ori/SimpleTables.vue`)
      // },
      // {
      //   path: 'user-tables',
      //   meta: {
      //     name: 'User Table',
      //     requiresAuth: true
      //   },
      //   component: () => import(`@/components/DashViews/ori/UsersTable.vue`)
      // },
      // {
      //   path: 'complex',
      //   meta: {
      //     name: 'Complex Table',
      //     requiresAuth: true
      //   },
      //   component: () => import(`@/components/DashViews/ori/ComplexTables.vue`)
      // },
      // {
      //   path: 'typography',
      //   meta: {
      //     name: 'Typography',
      //     requiresAuth: true
      //   },
      //   component: () => import(`@/components/DashViews/ori/Typography.vue`)
      // },
      // {
      //   path: 'icons',
      //   meta: {
      //     name: 'Icons',
      //     requiresAuth: true
      //   },
      //   component: () => import(`@/components/DashViews/ori/Icons.vue`)
      // },
      // {
      //   path: 'maps',
      //   meta: {
      //     name: 'Maps',
      //     requiresAuth: true
      //   },
      //   component: () => import(`@/components/DashViews/ori/Maps.vue`)
      // },
      // {
      //   path: 'notifications',
      //   meta: {
      //     name: 'Notifications',
      //     requiresAuth: true
      //   },
      //   component: () => import(`@/components/DashViews/ori/Notifications.vue`)
      // }
    ]
  },
  {
    path: '/project/overview',
    meta: {
      name: 'Project Overview',
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if (store.getters.hasPermission('MA_PROJECT')) {
        next()
      } else {
        next('/dashboard/project')
      }
    },
    component: () => import(`@/components/fullview/project/ProjectOverview.vue`)
  },
]
